import React, { useState } from "react";
import FilterChipDisplay from "../../../Filtering/FilterChipDisplay";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import ChannelFiltersDialog from "./ChannelFiltersDialog";


interface IChannelFiltersProps {
    client: string;
    channel: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ChannelFilters({ client, channel, changeFilter }: IChannelFiltersProps) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const text = `Channel: ${channel}`

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setDialogOpen(true)} />
            <ChannelFiltersDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                client={client}
                currentChannel={channel}
                changeFilter={changeFilter} />
        </>
    )
}